import { UseTranslationResponse } from "react-i18next";

const LINKEDIN_HOSTNANE = "linkedin.com";

export const bronzeFormTranslation = (
  translation: UseTranslationResponse<[string], undefined>,
  key: string
): string => {
  const prefix = "pass:olkypass.mainPage.olkypass.BronzeForms.";
  const completedKey = prefix + key;

  if (translation.i18n.exists(completedKey)) return translation.t(completedKey);
  return "";
};

export const isHttpUrlValid = (str: string) => {
  let url: URL;
  try {
    url = new URL(str);
    if (!url.hostname.endsWith(LINKEDIN_HOSTNANE)) return false;
  } catch (_) {
    return false;
  }
  return /https?/.test(url.protocol);
};
